const Pagination = require('./pagination');
const _ = require('lodash');

module.exports = {
  install: function(Vue, parameters) {
    Vue.prototype.$notify = function(opt) {
      var options = Object.assign({
        type: 'success',
        style: 'simple',
        position: 'top-right'
      }, opt);      
      $('body').pgNotification(options).show();
    };

    Vue.prototype.$error = function(error) {
      const options = {
        type: 'danger',
        style: 'simple',
        position: 'top',
        message: '[' + error.code + ']' + error.message + "<br/> " + JSON.stringify(error.response)
      };
      $('body').pgNotification(options).show();
    };

    Vue.prototype.$pagination = new Pagination();
    
    Vue.prototype.$query = '';
    Vue.prototype.$filters = {};    
    Vue.prototype._ = _;

    Vue.mixin({
      created: function() {
        this.$filters = {};
      },
      methods: {
        $applyFilter: function(key, value) {
          this.$filters[key] = value;      
        }
      },
      computed: {
        $params: {
          cache: false,
          get: function () {
            const validFilters = {};
            Object.keys(this.$filters).forEach(function(key) {
              if (typeof this.$filters[key] !== 'undefined' && this.$filters[key] !== null) {
                validFilters[key] = this.$filters[key];
              }
            });
            return Object.assign({
              query: this.$query,
              filters: validFilters
            }, this.$pagination.params);
          }          
        }
      },
      components: {
        'pg-breadcrumb': require('./breadcrumb.vue'),
        'pg-breadcrumb-item': require('./breadcrumb_item.vue'),
        'pg-button': require('./button.vue'),
        'pg-checkbox': require('./checkbox.vue'),
        'pg-container': require('./container.vue'),
        'pg-dropdown': require('./dropdown.vue'),
        'pg-fill-modal': require('./fill_modal.vue'),
        'pg-input': require('./input.vue'),
        'pg-jumbotron': require('./jumbotron.vue'),
        'pg-login': require('./login.vue'),
        'pg-modal': require('./modal.vue'),
        'pg-navbar': require('./navbar.vue'),
        'pg-pagination': require('./pagination.vue'),
        'pg-sidepanel': require('./side_panel.vue'),
        'pg-sidepanel-item': require('./side_panel_item.vue'),
        'pg-sidepanel-collection': require('./side_panel_collection.vue'),
        'pg-sidebar': require('./sidebar.vue'),        
        'pg-table-filter': require('./table_filter.vue'),
        'pg-table-header': require('./table_header.vue'),
        'pg-table-search': require('./table_search.vue'),
        'pg-multiselect': require('./vue-multiselect/dist/vue-multiselect.min').default,
        'pg-note': require('./note.vue'),
        'pg-notes': require('./notes.vue'),
        'pg-noteeditor': require('./note_editor.vue')
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/pages/plugin.js